export const environment = {
  production: true,
  showRouterTracing: Boolean(JSON.parse(localStorage.getItem('router-tracing'))) || false,
  useMockData: false
};
